import { abortIfNotPermitted } from '../utils';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "attendant-session" */ '@js/franchise_component/report/attendant-session/attendant-session-index.vue'),
        meta: {
            keepAlive: false,
        },
    },
    {
        path: '/:id',
        component: () =>
            import(/* webpackChunkName: "attendant-session" */ `@js/franchise_component/report/attendant-session/attendant-session-show.vue`),
        meta: {
            keepAlive: false,
        },
    },
];
